import { useState } from "react"
import ProfileThumbnail from '../assets/images/profile-thumb.png'

import Flex from './utils/Flex'
import TWInput from './utils/TWInput/TWInput'
import TWButton from './utils/TWButton/TWButton'

const SendTip = ({ onCancel }) => {

	const [tip, setTip] = useState({
		tip: '', message: ''
	})

	const onSubmit = () => {
		console.log('onSubmit')
	}

	return (
		<div className="p-3 lg:p-16">
			<div className="text-center">
				<img
					alt="profile-pic"
					src={ProfileThumbnail}
					className="h-12 w-12 rounded mx-auto object-center object-cover"
				/>
				<h4 className="mt-3 text-xl lg:text-2xl xl:text-3xl font-bold">Name</h4>
				<h6 className="text-base">@PhoriaUsername</h6>
				<p className="text-sm xl:text-lg text-gray-300">
					Enter the amount you wish to tip!
				</p>
			</div>
			<form onSubmit={onSubmit} className="mt-4 lg:mt-8">
				<TWInput
					dark
					name="tip"
					label="Tip"
					hint="$5.00"
					value={tip.tip}
					labelClass="w-28"
					className="mb-1 md:mb-6"
					inputClass="w-full"
					contentClass="w-full"
					onChange={e => setTip({ ...tip, tip: e.target.value })}
				/>
				<textarea
					rows="4"
					placeholder="Type your message"
					className="bg-secondary p-3 w-full text-xl"
				/>
				<Flex justify-between className="mt-10">
					<TWButton size="sm" color="primary" className="px-12">Send Tip</TWButton>
					<TWButton size="sm" className="px-12" onClick={() => onCancel && onCancel()}>
						Cancel
					</TWButton>
				</Flex>
			</form>
		</div>
	)
}

export default SendTip